module.exports = __webpack_public_path__ + "img/wp-new-habit-card12.1efa3e3c.jpg";